import { getParamFromSearchOrHash } from '@shared/core';
import { getEnv } from '@luna/env';
import { isOpenIdConnectEnabled } from '@shared/environment';
import { deleteCookie } from '@luna/cookies';
import type { RetailEnvironmentConfig } from '@retail/core-config';

export const GEORGE_ROOT = '/';

export function isCsrfFeatureEnabled(): boolean {
    if (isOpenIdConnectEnabled()) {
        return false;
    }
    return !!getEnv<RetailEnvironmentConfig>().csrfToken;
}

export function removeQueryStringParameter(_url: string, key: string): string {
    const regex = new RegExp(`([?&])${key}=.*?(&|#|$)`, 'i');
    let url = _url;

    if (url.match(regex)) {
        // remove key and value
        url = url.replace(regex, '$1');

        // remove trailing ? or &
        url = url.replace(/([?&])$/, '');
    }

    return url;
}

const MOBILE_WIDTH = 480;

function getClientId(georgeConfig: RetailEnvironmentConfig): string {
    if (
        georgeConfig.mobileClientId &&
        window &&
        window.screen &&
        window.screen.width <= MOBILE_WIDTH
    ) {
        return georgeConfig.mobileClientId;
    }

    return georgeConfig.clientId;
}

function attachParamToUrlIfExists(_url: string, urlParam: string): string {
    let url = _url;
    const existingParam = getParamFromSearchOrHash(urlParam);
    if (existingParam) {
        url += `&${urlParam}=${existingParam}`;
    }
    return url;
}

export function getLoginUrl(georgeConfig: RetailEnvironmentConfig, state: string): string {
    if (isOpenIdConnectEnabled()) {
        return GEORGE_ROOT;
    }

    const targetState = state;

    let loginURL = georgeConfig.loginUrl;
    let { clientId } = georgeConfig;

    if (clientId) {
        clientId = getClientId(georgeConfig);
    }

    loginURL = loginURL.replace('[[CLIENTID]]', clientId);
    loginURL = loginURL.replace('[[STATE]]', targetState);

    // whitelist params that can be pass from george to the login page
    loginURL = attachParamToUrlIfExists(loginURL, 'login_hint');

    return loginURL;
}

export function prepareState(_targetSection: string, csrfToken: string): string {
    let targetSection = _targetSection;

    if (typeof targetSection === 'undefined' && typeof csrfToken === 'undefined') {
        return '';
    }

    if (typeof targetSection === 'undefined') {
        targetSection = '';
    }

    if (typeof csrfToken === 'undefined') {
        return targetSection;
    }

    return encodeURIComponent(`${targetSection}||${csrfToken}`);
}

export function deleteCsrfCookie(): void {
    if (isCsrfFeatureEnabled()) {
        deleteCookie('gt_csrf');
    }
}
